import React from 'react'

function Footer() {
    return (
        <div className='footer'>
            <p>All rights reserved &copy; {new Date().getFullYear()} Astha Samaddar</p>
        </div>
    )
}

export default Footer
